import { legacyPaths } from './legacyPaths';
import { openApiPaths } from './openApiPaths';

export const openApiSchema = {
    openapi: '3.1.0',
    info: {
        version: '1.0.0',
        title: 'ZXY-Cloud',
    },
    paths: {
        ...legacyPaths,
        ...openApiPaths,
    },
} as const;
